import { useState, useContext, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { Table, Typography, Button, Space, Tag } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { toast, ToastContainer } from "react-toastify";

const { Link } = Typography;

export default function ApproveVenue() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [approvingId, setApprovingId] = useState(null);
    const [denyingId, setDenyingId] = useState(null);
    const { backUrl, authData } = useContext(AuthContext);
    const isMobile = window.innerWidth < 768;

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${backUrl}/api/emp/venues/`, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`,
                },
            });
            setData(res.data.results || []);
        } catch (err) {
            console.error("Error fetching venues:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleApprove = async (id) => {
        setApprovingId(id);
        try {
            await toast.promise(
                axios.post(
                    `${backUrl}/api/emp/venues/${id}/set-status/`,
                    { status: "Approved" },
                    { headers: { Authorization: `Bearer ${authData?.access}` } }
                ),
                {
                    pending: "Approving venue...",
                    success: "Venue approved successfully!",
                    error: "Failed to approve venue!",
                }
            );
            await fetchData();
        } catch (err) {
            console.error(err);
        } finally {
            setApprovingId(null);
        }
    };

    const handleDeny = async (id) => {
        setDenyingId(id);
        try {
            await axios.post(
                `${backUrl}/api/emp/venues/${id}/set-status/`,
                { status: "Rejected" },
                {
                    headers: { Authorization: `Bearer ${authData?.access}` },
                }
            );
            toast.success("Venue denied!");
            await fetchData();
        } catch (err) {
            toast.error("Failed to deny venue!");
            console.error(err);
        } finally {
            setDenyingId(null);
        }
    };

    const columns = [
        {
            title: "Venue",
            dataIndex: "venue",
            key: "venue",
        },
        {
            title: "Map Location",
            dataIndex: "map_location_link",
            key: "map_location_link",
            render: (link) => (
                <Link className="p-2" href={link} target="_blank">
                    View on Map
                </Link>
            ),
        },
        {
            title: "Submitted By",
            dataIndex: ["submitted_by", "first_name"],
            key: "submitted_by",
        },
        {
            title: "Submission Date",
            dataIndex: "submission_date",
            key: "submission_date",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status) => (
                <p
                    style={{
                        color:
                            status === "Pending"
                                ? "orange"
                                : status === "Approved"
                                    ? "green"
                                    : "red",
                        fontWeight: "bold",
                        margin: 0,
                    }}
                >
                    {status === "Rejected" ? "Denied" : status}
                </p>
            ),
        },
        {
            title: "Approve",
            key: "approve",
            render: (_, record) => (
                <Button
                    style={{ backgroundColor: '#0e497b', color: 'white' }}
                    icon={<CheckOutlined />}
                    onClick={() => handleApprove(record.id)}
                    disabled={record.status === "Approved" || approvingId === record.id || denyingId === record.id}
                    loading={approvingId === record.id}
                >
                    Approve
                </Button>
            ),
        },
        {
            title: "Deny",
            key: "deny",
            render: (_, record) => (
                <Button
                    danger
                    icon={<CloseOutlined />}
                    onClick={() => handleDeny(record.id)}
                    disabled={record.status === "Rejected" || denyingId === record.id || approvingId === record.id}
                    loading={denyingId === record.id}
                >
                    Deny
                </Button>
            ),
        },
    ];

    return (
        <div style={{ padding: 20 }}>
            <ToastContainer position="top-right" autoClose={3000} />
            {
                isMobile ? (
                    <center>
                        <p style={{ textTransform: 'uppercase' }}>Approve Venue</p>
                    </center>
                ) : (
                    <center>
                        <h3>Approve Venue</h3>
                    </center>
                )
            }

            <Table
                columns={columns}
                dataSource={data}
                rowKey="id"
                bordered
                loading={loading}
                pagination={{ pageSize: 5 }}
                style={{ marginTop: 20, width: "100%" }}
                components={{
                    header: {
                        cell: (props) => (
                            <th
                                {...props}
                                style={{ backgroundColor: "#0e497b", color: "white" }}
                            >
                                {props.children}
                            </th>
                        ),
                    },
                }}
                scroll={{ x: "max-content" }}
            />
        </div>
    );
}